<template lang="pug">
v-tab-item
    v-snackbar(top v-model="successMessage" color="success") Permissions updated successfully!
    v-snackbar(top v-model="error.show" color="red") {{ error.message }}
    feathers-vuex-find(service="vw-user-artists" :query="dataQuery" :fetch-query="fetchQuery" watch="query")
        v-card(slot-scope="{ items: desserts, pagination: serverPagination, isFindPending }")
            v-card-title Artists
                v-spacer
                v-text-field(v-model="searchUser" append-icon="mdi-magnify" label="Search" single-line hide-details)
            v-data-table(
                :headers="headers"
                :loading="isFindPending"
                :items="isFindPending ? [] : desserts"
                :options.sync="pagination"
                :server-items-length="!serverPagination ? 0 : serverPagination.mostRecent.total"
                :footer-props="{ showCurrentPage: true, itemsPerPageOptions: [10, 15, 20, 25, 30] }"
                loading-text="Fetching Data..."
            )
                template(v-slot:item.artist_name="{ item }")
                    v-avatar(size="30" style="margin-right: 10px;")
                        img(:src="item.profile_picture_thumb")
                    a(:href="`http://www.breakinghits.app/${item.url}`" :target="`__user-${item.id}`") {{ item.artist_name }}
                template(v-slot:item.date_added="{ item }") {{ item.date_added | dateFormat }}
                template(v-slot:item.status="{ item }") {{ item.status | status }}
                template(v-slot:item.actions="{ item }")
                    permissions-dialog(:item="item" @success="successMessage = true" @error="handleError")

</template>

<script>
import moment from 'moment';
import PermissionsDialog from '../../RoleManager/components/PermissionsDialog.vue';

export default {
    components: {
        PermissionsDialog
    },
    data() {
        return {
            searchUser: '',
            successMessage: false,
            error: {
                show: false,
                message: ''
            },
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: true,
                    value: 'id'
                },
                {
                    text: 'Full Name',
                    align: 'start',
                    sortable: true,
                    value: 'artist_name'
                },
                {
                    text: 'Genre',
                    align: 'start',
                    sortable: true,
                    value: 'genre'
                },
                {
                    text: 'Status',
                    align: 'start',
                    sortable: true,
                    value: 'status'
                },
                {
                    text: 'Date Registered',
                    align: 'end',
                    sortable: true,
                    value: 'date_added'
                },
                {
                    text: 'Actions',
                    align: 'end',
                    sortable: false,
                    value: 'actions'
                }
            ],
            pagination: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['date_added'],
                sortDesc: [true]
            },
            query: {},
        };
    },
    filters: {
        dateFormat(date) {
            if(date) {
                return moment(date).format('lll');
            }

            return 'n/a';
        },
        status(status) {
            switch(status) {
                case 0: return 'Inactive';
                case 1: return 'Active';
            }
        }
    },
    computed: {
        extendedQuery() {
            if(this.user) {
                return {
                    // id: { $nin: [this.user.id] }
                };
            }
            return null;
        },
        searchQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { artist_name: { $like: `%${this.searchUser}%` } },
                        { url: { $like: `%${this.searchUser}%` } },
                    ]
                };
            }
            return null;
        },
        searchDataQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { artist_name: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                        { utl: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                    ]
                };
            }
            return null;
        },
        sortingQuery() {
            if(this.pagination.sortBy.length !== 0) {
                const $sort = {};
                this.pagination.sortBy.map((item, index) => {
                    switch(item) {
                        case 'fullname':
                            $sort.fname = this.pagination.sortDesc[index] ? -1 : 1;
                            $sort.lname = this.pagination.sortDesc[index] ? -1 : 1;
                            break;
                        default:
                            $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                    }
                    
                });
                return { $sort };
            }
            return null;
        },
        dataQuery() {
            return {
                ...this.query,
                ...this.extendedQuery,
                ...this.searchDataQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            };
        },
        fetchQuery() {
            return Object.assign({}, {
                ...this.query,
                ...this.extendedQuery,
                // $populate: true
            }, {
                ...this.searchQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            });
        },
    },
    methods: {
        escapeRegex(string) {
            return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        },
        handleError(err) {
            this.error.show = true;
            this.error.message = err.message || 'An error occurred';
        }
    }
}
</script>